class BundlerBuilder extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.bundlePropertyKey =
      this.dataset.bundlePropertyKey || "_part_of_bundle";
    this.bundlePropertyValue =
      this.dataset.bundlePropertyValue || "Build your own bundle";
    // this.BUNDLE_VARIANT_ID = this.getAttribute("data-bundle-variant-id");
    this.navigation = this.querySelector(".bundler-builder--navigation");

    this.addToCartBtn = this.navigation.querySelector(
      "button[data-add-bundle-to-cart]"
    );

    this.productsGrid = this.querySelector(".bundler-builder--grid");

    // Purchase-type toggle + live summary
    this.discount3 = parseFloat(this.getAttribute("data-discount-3")) || 0;
    this.discount5 = parseFloat(this.getAttribute("data-discount-5")) || 0;
    this.purchaseTypeInputs = this.navigation.querySelectorAll(
      'input[name="byob-purchase-type"]'
    );
    this.summary = this.navigation.querySelector("[data-bundle-summary]");
    this.compareEl = this.navigation.querySelector("[data-bundle-compare]");
    this.totalEl = this.navigation.querySelector("[data-bundle-total]");
    this.savingsEl = this.navigation.querySelector("[data-bundle-savings]");

    // Mobile pinned checkout bar (mirrors the panel total + CTA)
    this.mobileBar = this.querySelector("[data-byob-mobile-bar]");
    this.barCount = this.querySelector("[data-byob-bar-count]");
    this.barTotal = this.querySelector("[data-byob-bar-total]");
    this.barCompare = this.querySelector("[data-byob-bar-compare]");
    this.barCta = this.querySelector("[data-byob-bar-cta]");
    if (this.barCta) {
      this.barCta.addEventListener("click", () => this.addToCart());
    }
    // Segmented one-time/subscribe switch inside the bar — drives the same
    // radios as the inline panel so the two stay in sync.
    this.barModeButtons = this.querySelectorAll("[data-byob-bar-mode]");
    this.barModeButtons.forEach((btn) =>
      btn.addEventListener("click", () =>
        this.setPurchaseType(btn.dataset.byobBarMode)
      )
    );
    // Mirror nav slot circles shown in the mobile bar
    this.barSlots = this.querySelector('[data-byob-bar-slots]');
    if (this.barSlots) {
      this.barSlots.addEventListener('click', (e) => {
        const slot = e.target.closest('[data-byob-bar-slot-index]');
        if (!slot || slot.dataset.navItemHasContent !== 'true') return;
        this.removeProductFromNavigation(slot.dataset.byobBarSlotIndex);
        this.setDisabledAddToCartBtn();
      });
    }
    // Re-parent the fixed bar to <body> so no ancestor stacking context or
    // transform traps it below the panel (which would block taps on the CTA).
    // Keep it always visible on mobile (CSS hides it on desktop); the CTA stays
    // disabled with a "pick 3+" hint until the bundle is valid.
    if (this.mobileBar) {
      this.mobileBar.hidden = false;
      document.body.appendChild(this.mobileBar);
    }

    this.purchaseTypeInputs.forEach((input) =>
      input.addEventListener("change", () => {
        this.updatePurchaseTypeUI();
        this.updateSummary();
      })
    );

    this.productsGrid.addEventListener(
      "input",
      this.productsGridInputEventHandler.bind(this)
    );
      this.productsGrid.addEventListener(
    "click",
    this.productsGridClickHandler.bind(this)
  );
    this.navigation.addEventListener(
      "click",
      this.navigationEventHandler.bind(this)
    );

    this.updatePurchaseTypeUI();
    this.updateSummary();
  }

  disconnectedCallback() {
    this.productsGrid.removeEventListener(
      "input",
      this.productsGridInputEventHandler.bind(this)
    );
    this.navigation.removeEventListener(
      "click",
      this.navigationEventHandler.bind(this)
    );
    // The bar was re-parented to <body>; remove it so a re-render (theme editor)
    // can't leave an orphaned/duplicate bar behind.
    if (this.mobileBar) this.mobileBar.remove();
  }
  productsGridClickHandler(event) {
    const gridItem = event.target.closest(".bundler-builder--grid-item");
    if (!gridItem) return;

    if (event.target.matches('input[type="checkbox"]')) return;

    // Only the card ATC button should trigger "add to bundle".
    const addBundleBtn = event.target.closest("#addBundleBtn");
    if (!addBundleBtn) return;

    const checkbox = gridItem.querySelector('input[type="checkbox"]');
    if (!checkbox) return;

    event.preventDefault();
    event.stopPropagation();

    checkbox.checked = !checkbox.checked;
    checkbox.dispatchEvent(new Event("input", { bubbles: true }));
  }


  productsGridInputEventHandler(event) {
    event.preventDefault();
    const input = event.target.closest(`input[type="checkbox"]`);
    if (!input) return;

    // Ignore native checkbox toggles from label/card clicks.
    // We only accept programmatic "input" events triggered by explicit CTAs.
    if (event.isTrusted) {
      input.checked = false;
      return;
    }

    const label = input.nextElementSibling;
    if (!label) return;
    const productImg = label.querySelector("img");
    if (!productImg) return;
    const productImgClone = productImg.cloneNode(true);

    if (this.checkBundleSize() > 5) {
      input.checked = false;
      return;
    }

    if (input.checked) {
      this.setProductImageInNavItem(
        productImgClone,
        input.value,
        input.dataset.sellingPlanId,
        input.dataset.priceCents
      );
    }
    input.checked = false;
    this.setDisabledAddToCartBtn();
  }

  navigationEventHandler(event) {
    const navItem = event.target.closest(".bundler-builder--nav-item");
    const button = event.target.closest("[data-add-bundle-to-cart]");

    if (navItem) {
      const { navItemIndex } = navItem.dataset;
      this.removeProductFromNavigation(navItemIndex);
      // this.removeCheckedProduct(navItemProdId);
      this.setDisabledAddToCartBtn();
    }

    if (button) {
      this.addToCart();
    }
  }

  setProductImageInNavItem(imgElement, productId, sellingPlanId, priceCents) {
    const emptyNavItem = this.getEmptyNavItem();
    if (!emptyNavItem) return;

    emptyNavItem.appendChild(imgElement);
    emptyNavItem.dataset.navItemProdId = productId;
    emptyNavItem.dataset.navItemHasContent = true;
    emptyNavItem.dataset.navItemSellingPlanId = sellingPlanId || "";
    emptyNavItem.dataset.navItemPrice = priceCents || "";
  }

  //add to cart individual products
  async addToCart() {
    const purchaseType = this.getPurchaseType();
    const navItems = this.getSelectedNavItems();

    if (navItems.length < 3 || navItems.length > 5) {
      console.error("The bundle must contain 3 to 5 items.");
      return;
    }

    this.setLoadingStateAddToCartBtn(true);

    try {
      const bundleProperties = this.getBundleProperties();
      const items = navItems.map((navItem) => {
        const lineItem = {
          id: navItem.dataset.navItemProdId,
          quantity: 1,
          ...(bundleProperties ? { properties: bundleProperties } : {}),
        };
        return lineItem;
      });

      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) throw new Error("Error adding products to cart");

      console.log("Productos agregados individualmente al carrito 🎉");
    } catch (error) {
      console.error(`Bundler Build | addToCart | ${error}`);
    } finally {
      this.setLoadingStateAddToCartBtn(false);
      this.resetElements();
      this.setDisabledAddToCartBtn();
      openCartDrawer(true);
    }
  }
  //end add to cart individual products

  getEmptyNavItem() {
    return this.navigation.querySelector(
      `.bundler-builder--nav-item[data-nav-item-has-content="false"]`
    );
  }

  
  removeProductFromNavigation(navItemIndex) {
    const deletedIndex = Number(navItemIndex);

    const allSlots = Array.from(
      this.navigation.querySelectorAll(".bundler-builder--nav-item")
    ).sort((a, b) => Number(a.dataset.navItemIndex) - Number(b.dataset.navItemIndex));

    const deletedPos = allSlots.findIndex(
      (el) => Number(el.dataset.navItemIndex) === deletedIndex
    );

    if (deletedPos === -1) return;

    for (let i = deletedPos; i < allSlots.length; i++) {
      const next = allSlots[i + 1];

      if (next && next.dataset.navItemHasContent === "true") {
        allSlots[i].dataset.navItemHasContent = "true";
        allSlots[i].dataset.navItemProdId = next.dataset.navItemProdId;
        allSlots[i].dataset.navItemSellingPlanId = next.dataset.navItemSellingPlanId;
        allSlots[i].dataset.navItemPrice = next.dataset.navItemPrice;
        allSlots[i].innerHTML = next.innerHTML;
      } else {
        allSlots[i].dataset.navItemHasContent = "false";
        allSlots[i].dataset.navItemProdId = "";
        allSlots[i].dataset.navItemSellingPlanId = "";
        allSlots[i].dataset.navItemPrice = "";
        allSlots[i].innerHTML = "";
        break;
      }
    }
  }

  // removeCheckedProduct(productId) {
  //   this.productsGrid.querySelector(
  //     `input[type="checkbox"][value="${productId}"]`
  //   ).checked = false;
  // }

  setDisabledAddToCartBtn() {
    const checkedProducts = this.checkBundleSize();
    const label = checkedProducts < 3 ? "ADD MORE" : "ADD TO CART";
    this.addToCartBtn.disabled = checkedProducts < 3;
    this.addToCartBtn.textContent = label;
    if (this.barCta) {
      this.barCta.disabled = checkedProducts < 3;
      this.barCta.textContent = label;
    }
    this.updateSummary();
  }

  getSelectedNavItems() {
    return Array.from(
      this.navigation.querySelectorAll(
        `.bundler-builder--nav-item[data-nav-item-has-content="true"]`
      )
    );
  }

  getPurchaseType() {
    return "one_time";
  }

  setPurchaseType(type) {
    const radio = this.navigation.querySelector(
      `input[name="byob-purchase-type"][value="${type}"]`
    );
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
    } else {
      this.updatePurchaseTypeUI();
      this.updateSummary();
    }
  }

  getActiveDiscount() {
    const count = this.getSelectedNavItems().length;
    if (count >= 5) return this.discount5;
    if (count >= 3) return this.discount3;
    return 0;
  }

  updatePurchaseTypeUI() {
    const type = this.getPurchaseType();
    this.navigation
      .querySelectorAll(".bundler-purchase-option")
      .forEach((opt) => {
        opt.classList.toggle("is-selected", opt.dataset.purchaseType === type);
      });
    if (this.barModeButtons) {
      this.barModeButtons.forEach((btn) => {
        const active = btn.dataset.byobBarMode === type;
        btn.classList.toggle("is-selected", active);
        btn.setAttribute("aria-pressed", active ? "true" : "false");
      });
    }
  }

  formatMoney(cents) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format((cents || 0) / 100);
  }

  updateSummary() {
    const navItems = this.getSelectedNavItems();
    const count = navItems.length;
    const subtotalCents = navItems.reduce(
      (sum, el) => sum + (parseInt(el.dataset.navItemPrice, 10) || 0),
      0
    );
    const discount = this.getActiveDiscount();
    const savingsCents = Math.round(subtotalCents * (discount / 100));
    const totalCents = subtotalCents - savingsCents;
    const compareText =
      count > 0 && discount > 0 ? this.formatMoney(subtotalCents) : "";
    const totalText = this.formatMoney(totalCents);

    // Desktop / inline panel summary
    if (this.summary) {
      this.summary.hidden = count === 0;
      if (this.compareEl) this.compareEl.textContent = compareText;
      if (this.totalEl) this.totalEl.textContent = totalText;
      if (this.savingsEl) {
        this.savingsEl.textContent =
          count > 0 && discount > 0
            ? `You save ${this.formatMoney(savingsCents)} (${discount}% OFF)`
            : "";
      }
    }

    // Mobile pinned checkout bar (always visible on mobile; CTA enables at 3)
    if (this.mobileBar) {
      if (this.barCount) {
        this.barCount.textContent = `${count} item${count === 1 ? "" : "s"}`;
      }
      if (this.barCompare) this.barCompare.textContent = compareText;
      if (this.barTotal) this.barTotal.textContent = count === 0 ? "" : totalText;
    }
    this.syncMobileBarSlots();
  }

  syncMobileBarSlots() {
    if (!this.barSlots) return;
    const navItems = this.navigation.querySelectorAll('.bundler-builder--nav-item');
    navItems.forEach((navItem) => {
      const index = navItem.dataset.navItemIndex;
      const barSlot = this.barSlots.querySelector(`[data-byob-bar-slot-index="${index}"]`);
      if (!barSlot) return;
      barSlot.dataset.navItemHasContent = navItem.dataset.navItemHasContent;
      barSlot.innerHTML = navItem.innerHTML;
    });
    this.updateDiscountBadges();
  }

  updateDiscountBadges() {
    // Slot-shifting copies innerHTML between slots, so sweep stray badges
    // from every slot before re-adding them where they belong.
    this.querySelectorAll('.byob-slot-badge').forEach((b) => b.remove());
    if (this.barSlots) {
      this.barSlots.querySelectorAll('.byob-slot-badge').forEach((b) => b.remove());
    }

    const BADGE_SLOTS = [{ index: '3', discount: this.discount3 }];

    if (this.discount5 !== this.discount3) {
      BADGE_SLOTS.push({ index: '5', discount: this.discount5 });
    }

    BADGE_SLOTS.forEach(({ index, discount }) => {
      // Desktop nav item
      const navItem = this.navigation.querySelector(`.bundler-builder--nav-item[data-nav-item-index="${index}"]`);
      // Mobile bar slot
      const barSlot = this.barSlots
        ? this.barSlots.querySelector(`[data-byob-bar-slot-index="${index}"]`)
        : null;

      [navItem, barSlot].forEach((el) => {
        if (!el) return;
        const badge = document.createElement('span');
        badge.className = 'byob-slot-badge';
        badge.textContent = `${discount}% OFF`;
        el.appendChild(badge);
      });
    });
  }

  setLoadingStateAddToCartBtn(flag) {
    this.addToCartBtn.disabled = flag;
  }

  checkBundleSize() {
    const navItems = this.navigation.querySelectorAll(
      `[data-nav-item-has-content="true"]`
    );

    return navItems ? navItems.length : 0;
  }

  getProductsIds() {
    return Array.from(
      this.navigation.querySelectorAll(
        `.bundler-builder--nav-item[data-nav-item-has-content="true"]`
      )
    )
      .map((el) => el.dataset.navItemProdId)
      .filter(Boolean);
  }

  getBundleProperties() {
    if (!this.bundlePropertyKey) return null;

    return {
      [this.bundlePropertyKey]: this.bundlePropertyValue || "",
    };
  }

  getBundleDetails() {
    // Build a human-readable descriptor for each selection to fuel the Rebuy cart template
    return Array.from(
      this.navigation.querySelectorAll(
        `.bundler-builder--nav-item[data-nav-item-has-content="true"]`
      )
    )
      .map((navItem) => {
        const productId = navItem.dataset.navItemProdId;
        if (!productId) return "";

        const checkbox = this.productsGrid.querySelector(
          `input[type="checkbox"][value="${productId}"]`
        );
        if (!checkbox) return "";

        const label = checkbox.nextElementSibling;
        if (!label) return "";

        const title = label
          .querySelector(".bundler-product-title")
          ?.textContent.trim();

        const detailParts = [];
        if (title) detailParts.push(title);

        return detailParts.join(" | ");
      })
      .filter(Boolean);
  }

  resetElements() {
    this.navigation
      .querySelectorAll(".bundler-builder--nav-item")
      .forEach((el) => {
        el.dataset.navItemProdId = "";
        el.dataset.navItemHasContent = false;
        el.dataset.navItemSellingPlanId = "";
        el.dataset.navItemPrice = "";
        el.innerHTML = "";
      });

    this.productsGrid
      .querySelectorAll(".bundler-builder--grid-item input[type='checkbox']")
      .forEach((el) => {
        el.checked = false;
      });
  }
}
customElements.define("bundler-builder", BundlerBuilder);
